// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3LdFB","col":"CardReaderDesc_col__W405U","label":"CardReaderDesc_label__2h3Fi"};